// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__voVS1","formControl":"addForm_formControl__X9Z8U","list":"addForm_list__VbSnZ","btnWrpper":"addForm_btnWrpper__yVvUp"};